import { createApi } from '@reduxjs/toolkit/query/react';
import axiosFetchBase from '../axiosFetchBase.js';
import { urls } from '../../utils/helpers/ApiClient.jsx';
import { studyProgramsApi } from './study_programs.jsx';

export const studyProgramTypesApi = createApi({
  reducerPath: 'studyProgramTypesApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getStudyProgramTypes: builder.query({
      query: () => ({
        url: urls.studyProgramTypes,
      }),
    }),
  }),
});

export const { useGetStudyProgramTypesQuery: useGetStudyProgramTypesQuery } =
  studyProgramTypesApi;
